
define('ldsh!modules/editor/templates/elements/area', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="js-area-elements"></div>\n';

}
return __p
};});

